import React from "react";

const SavedEmails = ({ emails, toggleEmails }) => {
  console.log("SavedEmails");
  return (
    <ul className="emails__saved" onClick={() => toggleEmails("to")}>
      {emails.map((email) => (
        <li key={email.email} className="emails__saved-item">
          {email.email}
        </li>
      ))}
    </ul>
  );
};

export default SavedEmails;
